import styled from 'styled-components';

export const UpdateReportAssigneeText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBody}
  color: ${(props) => props.theme.newPalette.neutral.N600};
  margin: 0;
`;

export const UpdateReportAssigneeBoldText = styled.b`
  ${(props) => props.theme.newTypography.textStyleBodySemibold}
  color: ${(props) => props.theme.newPalette.neutral.N800};
`;
